import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {plainToClassFromExist} from "class-transformer";
import {ResultListApiModel} from "../models/result-list.api.model";
import {QueryParamsService} from "../../core/services/query-params.service";
import {QueryParamsApiModel} from "../models/query-params-api.model";
import {EquipmentCategoryApiModel} from "../models/equipment-category.api-model";

@Injectable()
export class EquipmentCategoryRestService {
  private readonly resource: string = '/equipment_categories';

  constructor(
    public http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  public getCollection(queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()): Observable<ResultListApiModel<EquipmentCategoryApiModel>> {
    queryParamsApiModel.pagination = false;
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<EquipmentCategoryApiModel>>(environment.apiUrl + this.resource, {params})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<EquipmentCategoryApiModel>(EquipmentCategoryApiModel), result as object)));
  }
}
